export default __webpack_public_path__ + "static/media/pg-16.58612301.jpg";